import { CommonModule } from '@angular/common'
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { NgxMatIntlTelInputModule } from '../../../lib/ngx-mat-intl-tel-input/ngx-mat-intl-tel-input.module'
import { AppMaterialModule } from '../app-material.module'
// Components
import { AddChannelsComponent } from './add-channels/add-channels.component'
import { FacebookComponent } from './add-channels/facebook/facebook.component'
import { TelegramComponent } from './add-channels/telegram/telegram.component'
import { WebchatComponent } from './add-channels/webchat/webchat.component'
import { WhatsappPlaygroundComponent } from './add-channels/whatsapp-playground/whatsapp-playground.component'
import { WhatsappComponent } from './add-channels/whatsapp/whatsapp.component'
import { AddIntegrationComponent } from './add-integration/add-integration.component'
import { ZendeskComponent } from './add-integration/zendesk/zendesk.component'
import { AppVersionComponent } from './app-version/app-version.component'
import { AssignAgentsToQueueModalComponent } from './assign-agents-to-queue-modal/assign-agents-to-queue-modal.component'
import { AwayDialogComponent } from './away-dialog/away-dialog.component'
import { BanUserDialogComponent } from './ban-user-dialog/ban-user-dialog.component'
import { BaseModule } from './base/base.module'
import { ChangeBotNameComponent } from './change-bot-name/change-bot-name.component'
import { ChannelDetailComponent } from './channel-detail/channel-detail.component'
import { CompleteProfileComponent } from './complete-profile/complete-profile.component'
import { DeleteBotConfirmComponent } from './delete-bot-confirm/delete-bot-confirm.component'
import { BotDeleteOrResolveDialogComponent } from './delete_or_transfer-dialog/bot-delete_or_resolve-dialog.component'
import { FilterUserStatusComponent } from './filter-user-status/filter-user-status.component'
import { ListChannelsComponent } from './list-channels/list-channels.component'
import { NoAuthPageComponent } from './no-auth-page/no-auth-page.component'
import { PusherStatusHandlerComponent } from './pusher-status-handler/pusher-status-handler.component'
import { QueueSelectorComponent } from './queue-selector/queue-selector.component'
import { RequestLicensesModalComponent } from './request-licenses-modal/request-licenses-modal.component'
import { SetNewPasswordComponent } from './set-new-password/set-new-password.component'
import { SharedBrandModule } from './shared-brand/shared-brand.module'
import { SharedCoreModule } from './shared-core/shared-core.module'
import { UserListComponent } from './user-list/user-list.component'
import { WebchatSettingsComponent } from './webchat-settings/webchat-settings.component'
import { WebchatSnippetComponent } from './webchat-snippet/webchat-snippet.component'
import { WhitelistedUrlsComponent } from './whitelisted-urls/whitelisted-urls.component'

@NgModule({
  declarations: [
    AppVersionComponent,
    TelegramComponent,
    FacebookComponent,
    WhatsappComponent,
    WhatsappPlaygroundComponent,
    WebchatComponent,
    WebchatSettingsComponent,
    WebchatSnippetComponent,
    ZendeskComponent,
    ListChannelsComponent,
    QueueSelectorComponent,
    AwayDialogComponent,
    BotDeleteOrResolveDialogComponent,
    AddChannelsComponent,
    ChannelDetailComponent,
    AddIntegrationComponent,
    ChangeBotNameComponent,
    DeleteBotConfirmComponent,
    WhitelistedUrlsComponent,
    BanUserDialogComponent,
    PusherStatusHandlerComponent,
    AssignAgentsToQueueModalComponent,
    UserListComponent,
    FilterUserStatusComponent,
    SetNewPasswordComponent,
    CompleteProfileComponent,
    NoAuthPageComponent,
    RequestLicensesModalComponent,
  ],
  exports: [
    AppVersionComponent,
    TelegramComponent,
    FacebookComponent,
    WhatsappComponent,
    WhatsappPlaygroundComponent,
    WebchatComponent,
    WebchatSettingsComponent,
    WebchatSnippetComponent,
    ZendeskComponent,
    ListChannelsComponent,
    BotDeleteOrResolveDialogComponent,
    QueueSelectorComponent,
    AwayDialogComponent,
    AddChannelsComponent,
    ChannelDetailComponent,
    AddIntegrationComponent,
    ChangeBotNameComponent,
    DeleteBotConfirmComponent,
    WhitelistedUrlsComponent,
    PusherStatusHandlerComponent,
    AssignAgentsToQueueModalComponent,
    UserListComponent,
    FilterUserStatusComponent,
    CompleteProfileComponent,
    NoAuthPageComponent,
    RequestLicensesModalComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    FlexLayoutModule,
    NgxMatIntlTelInputModule,
    AppMaterialModule,
    SharedCoreModule,
    SharedBrandModule,
    BaseModule,
  ],
  providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class SharedComponentModule {}
